import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState } from 'src/entity/StateEntity';
import MallPharmacyListPage from 'src/components/views/Mall/PharmacyList';

const mapStateToProps = ({ userState: { userInfo, isAgent }, mallBrandState: { brandList }, taskState: taskState }: IStoreState) => ({
  isAgent,
  userInfo,
  brandList: brandList || [],
  taskState,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MallPharmacyListPage);



// WEBPACK FOOTER //
// ./src/containers/MallPharmacyList.ts